import { CircularProgress } from "@mui/material";

const CircularLoader = () => {
  return (
    <div
      style={{
        height: 500,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress />
    </div>
  );
};

export default CircularLoader;
